/* eslint-disable import/no-anonymous-default-export */
export default {
    gutterBottom: {
        marginBottom: 8,
    },
};
